/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgramDetails } from './ProgramDetails';
import {
    ProgramDetailsFromJSON,
    ProgramDetailsFromJSONTyped,
    ProgramDetailsToJSON,
} from './ProgramDetails';
import type { ProgramMetaData } from './ProgramMetaData';
import {
    ProgramMetaDataFromJSON,
    ProgramMetaDataFromJSONTyped,
    ProgramMetaDataToJSON,
} from './ProgramMetaData';

/**
 * 
 * @export
 * @interface Program
 */
export interface Program {
    /**
     * 
     * @type {ProgramMetaData}
     * @memberof Program
     */
    metaData: ProgramMetaData;
    /**
     * 
     * @type {ProgramDetails}
     * @memberof Program
     */
    details?: ProgramDetails | null;
}

/**
 * Check if a given object implements the Program interface.
 */
export function instanceOfProgram(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metaData" in value;

    return isInstance;
}

export function ProgramFromJSON(json: any): Program {
    return ProgramFromJSONTyped(json, false);
}

export function ProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): Program {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metaData': ProgramMetaDataFromJSON(json['metaData']),
        'details': !exists(json, 'details') ? undefined : ProgramDetailsFromJSON(json['details']),
    };
}

export function ProgramToJSON(value?: Program | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metaData': ProgramMetaDataToJSON(value.metaData),
        'details': ProgramDetailsToJSON(value.details),
    };
}

